var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.compontentType,{tag:"component",staticClass:"button-outline brdr-none px40 py10 brdr-50px no-outline bg-cl-transparent no-underline light fs-medium-small button-full border-box",class:{
    light : _vm.color === 'light', 'brdr-white' : _vm.color === 'black', 'light' : _vm.color === 'light',
    dark : _vm.color === 'dark', 'brdr-darkgray' : _vm.color === 'dark', 'cl-black' : _vm.color === 'dark',
    px0 : _vm.link ? true : false,
    'disabled button-disabled': _vm.disabled
  },attrs:{"to":_vm.redirectionLink,"disabled":_vm.disabled}},[_vm._t("default",[_vm._v(_vm._s(_vm.title))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }